import { render, staticRenderFns } from "./record.vue?vue&type=template&id=001a97d3&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.vue?vue&type=style&index=0&lang=css&"
import style1 from "./record.vue?vue&type=style&index=1&id=001a97d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a97d3",
  null
  
)

export default component.exports